import React from 'react';
import { useTranslation } from 'react-i18next';

// Material UI
import { makeStyles } from '@material-ui/core/styles';
import { DropzoneArea } from 'material-ui-dropzone';
import MapIcon from '@material-ui/icons/Map';

import CenteredProgress from '../../../../../utils/centeredprogress';
import { useGeofileHead } from '@graniot/common/adapters/sentinel';

const useStyles = makeStyles((theme) => ({
}));

export default function UploadGeoFiles({
    setFiles,
    setData,
    parcel
}) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [convertingFile, setConvertingFile] = React.useState(false);
    const mutateGeofileHead = useGeofileHead();

    const handleFileUploading = (files) => {
        if (files.length > 0) {
            setConvertingFile(true);
            setFiles({ attachments: files })
            mutateGeofileHead.mutate({ attachments: files, parcel_id: parcel.id });
        }
    };

    React.useEffect(() => {
        if (mutateGeofileHead.isSuccess) {
            console.log(mutateGeofileHead.data)
            setData(mutateGeofileHead.data);
            mutateGeofileHead.reset();
        }
    }, [mutateGeofileHead])

    return (
        <>
            {convertingFile ? <CenteredProgress /> : <DropzoneArea
                Icon={MapIcon}
                dropzoneText={"Drag and drop these file formats: .geojson, .json, .kml, .gml, or a zip package with your .shp .dbf .prj"}
                showAlerts={false}
                filesLimit={1}
                //showPreviewsInDropzone={true}
                //showFileNames
                //useChipsForPreview
                //previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                //previewChipProps={{ classes: { root: classes.previewChip } }}
                //previewText="Selected files"
                onChange={(files) => handleFileUploading(files)}
            />}
        </>
    );

};
